import React from "react";
// import Footer from "./Footer";
import Navigation from "./Navigation";
import { AuthLayoutProps } from "../../types/layouts/AuthLayout/AuthLayout";
import Header from "./header/header";

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <main className="mainContentBox">
      <div className="g-0 vh-100 d-flex position-relative overflow-hidden">
        <Navigation />
        <div className="h-100 mw-1">
          <div className="d-flex flex-column h-100">
            <Header />

            <div className="overflow-auto">
              <div className="px-3 px-xl-4 pb-4 pt-4">{children}</div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </main>
  );
};

export default AuthLayout;
